<template>
  <div class="form-field form-selector" :rel="name" v-bind:class="{'form-required': requiredForm}">
    <div class="form-label">
      <label>{{ label }}</label>
    </div>
    <div class="form-input">
      <div class="selector" :class="className">
        <div class="selector-label" @click="selectType(null)" v-bind:class="{'active':internalValue == null}">
          <icon name="file-06"/>
          <div>
            <strong>Standard</strong>
            <p>Facture de prestations uniquement</p>
          </div>
        </div>
        <div class="selector-label" @click="selectType('shipping')" v-bind:class="{'active':internalValue == 'shipping'}">
          <icon name="package"/>
          <div>
            <strong>Expédition</strong>
            <p>Expédition à domicile via transporteur</p>
          </div>
        </div>
        <div class="selector-label" @click="selectType('delivery')" v-bind:class="{'active':internalValue == 'delivery'}">
          <icon name="truck-01"/>
          <div>
            <strong>Livraison</strong>
            <p>Livraison à domicile</p>
          </div>
        </div>
        <div class="selector-label" @click="selectType('pickup')" v-bind:class="{'active':internalValue == 'pickup'}">
          <icon name="marker-pin-04"/>
          <div>
            <strong>Retrait</strong>
            <p>Retrait en magasin</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'ShippingType',
        props: ['value', 'label', 'name', 'placeholder', 'index', 'callback','required', 'disabled', 'className'],
        data: function () {
            return {
                internalValue: null,
                requiredForm: false
            }
        },
        created: function() {
            this.onChange = this.callback ? true : false;
            this.requiredForm = this.required && this.required == 'true' ? true : false
        },
        methods: {
          selectType: function(type)
          {
            this.internalValue = type;
            this.$forceUpdate()
          },
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal;
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', newVal);
                if( this.onChange ){
                    this.callback(newVal)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/ShippingType.vue